import { createSelector } from 'reselect';
import { infoSelector } from '../App/AppSelector';

export const selectTermsRawText = ({ Terms: { termsRawText } }) => termsRawText;

export const selectIsAcceptingTerms = ({ Terms: { isAcceptingTerms } }) => isAcceptingTerms;

export const selectIsFetchingTerms = ({ Terms: { isFetchingTerms } }) => isFetchingTerms;

export const selectAreTermsAccepted = ({ Terms: { areTermsAccepted } }) => areTermsAccepted;

export const selectAreDataAggregationTermsAccepted = ({
  Terms: { areDataAggregationTermsAccepted },
}) => areDataAggregationTermsAccepted;

export const selectWhitelabelLogo = createSelector(
  infoSelector,
  ({ WhiteLabel }) => WhiteLabel && WhiteLabel.logo,
);
